import { React, classNames } from '@digsup/core-ui';
import { styles } from './LabTube.scss';

const cx = classNames.bind(styles);

export const LabTube = () => (
  <div className={cx('l-homepage-hero-lab-tube')}>
    <div className="l-homepage-hero-lab-tube__liquid" />
    <div className="l-homepage-hero-lab-tube__bubbles">
      <div className="l-homepage-hero-lab-tube__bubble l-homepage-hero-lab-tube__bubble--right">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          width="31.762"
          height="31.845"
          viewBox="0 0 31.762 31.845">
          <defs>
            <linearGradient
              id="linear-gradient"
              y1="0.5"
              x2="1"
              y2="0.5"
              gradientUnits="objectBoundingBox">
              <stop offset="0" stopColor="#ed36c9" />
              <stop offset="1" stopColor="#01337b" />
            </linearGradient>
          </defs>
          <path
            id="Path_18586"
            data-name="Path 18586"
            d="M23.787-5913.814c-2.623-8.391-10.871-11.747-19.262-9.124s-13.647,9.693-11.024,18.083,12.131,14.924,20.522,12.3S26.41-5905.424,23.787-5913.814Z"
            transform="translate(7.178 5923.812)"
            fill="url(#linear-gradient)"
          />
        </svg>
      </div>
      <div className="l-homepage-hero-lab-tube__bubble l-homepage-hero-lab-tube__bubble--right">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          width="10.604"
          height="11.537"
          viewBox="0 0 10.604 11.537">
          <defs>
            <linearGradient
              id="linear-gradient"
              y1="0.5"
              x2="1"
              y2="0.5"
              gradientUnits="objectBoundingBox">
              <stop offset="0" stopColor="#ed36c9" />
              <stop offset="1" stopColor="#01337b" />
            </linearGradient>
          </defs>
          <path
            id="Path_18588"
            data-name="Path 18588"
            d="M-50.32-6013.274c-2.236,1.143-3.429,3.614-2.187,7.017a5.845,5.845,0,0,0,4.985,3.93c3.069.2,4.744-2.251,5.079-5.142C-41.94-6011.818-46.422-6015.266-50.32-6013.274Z"
            transform="translate(53.008 6013.853)"
            fill="url(#linear-gradient)"
          />
        </svg>
      </div>
      <div className="l-homepage-hero-lab-tube__bubble l-homepage-hero-lab-tube__bubble--left">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          width="14.357"
          height="13.687"
          viewBox="0 0 14.357 13.687">
          <defs>
            <linearGradient
              id="linear-gradient"
              y1="0.5"
              x2="1"
              y2="0.5"
              gradientUnits="objectBoundingBox">
              <stop offset="0" stopColor="#ed36c9" />
              <stop offset="1" stopColor="#01337b" />
            </linearGradient>
          </defs>
          <path
            id="Path_18587"
            data-name="Path 18587"
            d="M-91.84-5932.508c-3.779-.006-6.847,2.216-6.853,5.995s3.051,7.686,6.831,7.692,7.52-3.889,7.526-7.668S-88.06-5932.5-91.84-5932.508Z"
            transform="translate(98.693 5932.508)"
            fill="url(#linear-gradient)"
          />
        </svg>
      </div>
      <div className="l-homepage-hero-lab-tube__bubble l-homepage-hero-lab-tube__bubble--left">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          width="6.823"
          height="6.785"
          viewBox="0 0 6.823 6.785">
          <defs>
            <linearGradient
              id="linear-gradient"
              y1="0.5"
              x2="1"
              y2="0.5"
              gradientUnits="objectBoundingBox">
              <stop offset="0" stopColor="#ed36c9" />
              <stop offset="1" stopColor="#01337b" />
            </linearGradient>
          </defs>
          <path
            id="Path_18585"
            data-name="Path 18585"
            d="M-71.426-5966.276c-1.3,1.3-.782,3.35.518,4.65s3.12,1.588,4.421.288a3.7,3.7,0,0,0,.287-5A3.989,3.989,0,0,0-71.426-5966.276Z"
            transform="translate(72.18 5967.28)"
            fill="url(#linear-gradient)"
          />
        </svg>
      </div>
    </div>
  </div>
);
